import React from 'react'
import Feature1 from '../../Assets/Feature1 Picture.jpg'
import Noest from '../../Assets/Noest.jpg'
import Maystro from '../../Assets/Maystro.png'
import yalidin from '../../Assets/yalidine-logo.png'
import EMS from '../../Assets/EMS.jpg'
import ADSIL from '../../Assets/ADSIL.jpg'
import ZRexpress from '../../Assets/ZRexpress.png'
import { useTranslation } from 'react-i18next';

const Features = () => {
  const { t, i18n } = useTranslation();
    return (
        <div id='Features'>
        <section className="bg-white dark:bg-Eerie-Black ">
            <div className="container px-6 py-10 mx-auto">
                <div className="lg:flex lg:items-center">
                    <div className="w-full space-y-12 lg:w-1/2 ">
                        <div>
                            <h1 className="text-2xl font-semibold text-Eerie-Black capitalize lg:text-3xl dark:text-white">{t('Features.explore')}</h1>
                            <div className="mt-2">
                                <span className="inline-block w-40 h-1 bg-Ripe-mango dark:bg-white rounded-full"></span>
                                <span className="inline-block w-3 h-1 ml-1 bg-Eerie-Black dark:bg-Ripe-mango  rounded-full"></span>
                                <span className="inline-block w-1 h-1 ml-1 bg-Eerie-Black dark:bg-Ripe-mango rounded-full"></span>
                            </div>
                        </div>
                        <div className="md:flex md:items-start md:-mx-4">
                            <span className="inline-block p-2 text-Eerie-Black bg-blue-300 rounded-xl md:mx-4 dark:text-white dark:bg-Ripe-mango">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                                </svg>
                            </span>

                            <div className="mt-4 md:mx-4 md:mt-0">
                                <h1 className="text-xl font-semibold text-Eerie-Black capitalize dark:text-white">{t('Features.taskManagement')}</h1>

                                <p className="mt-3 text-Eerie-Black-light dark:text-gray-300">
                                {t('Features.taskManagementDesc')}                                </p>
                            </div>
                        </div>

                        <div className="md:flex md:items-start md:-mx-4">
                            <span className="inline-block p-2 text-Eerie-Black bg-blue-300  rounded-xl md:mx-4 dark:text-white dark:bg-Ripe-mango">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                                </svg>
                            </span>

                            <div className="mt-4 md:mx-4 md:mt-0">
                                <h1 className="text-xl font-semibold text-Eerie-Black capitalize dark:text-white">{t('Features.fileSharing')}</h1>

                                <p className="mt-3 text-Eerie-Black-light dark:text-gray-300">
                                {t('Features.fileSharingDesc')}                                </p>
                            </div>
                        </div>

                        <div className="md:flex md:items-start md:-mx-4">
                            <span className="inline-block p-2 text-Eerie-Black bg-blue-300  rounded-xl md:mx-4 dark:text-white dark:bg-Ripe-mango">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                                </svg>
                            </span>

                            <div className="mt-4 md:mx-4 md:mt-0">
                                <h1 className="text-xl font-semibold text-Eerie-Black capitalize dark:text-white">{t('Features.teamCollaboration')}</h1>
                                <p className="mt-3 text-Eerie-Black-light dark:text-gray-300">
                                  {t('Features.teamCollaborationDesc')}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="hidden lg:flex lg:items-center lg:w-1/2 lg:justify-center">
                        <img className="w-[28rem] h-[28rem] object-cover xl:w-[34rem] xl:h-[34rem] rounded-full" src={Feature1} alt="" />
                    </div>
                </div>

                <hr className="my-12 border-gray-200 dark:border-gray-700"/>
            </div>
        </section>
        <div className='bg-gray-100 w-full dark:bg-Eerie-Black '>
          <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20 text-Eerie-Black  dark:text-white ">
          <h2 className="mb-8 text-4xl font-bold  leading-none text-center">{t('Features.exploreServices')}</h2>
          <ul className={`${i18n.language === 'ar' ? 'lg:mr-32 grid gap-3 md:grid-cols-2 lg:grid-cols-3' :'lg:ml-32 grid gap-3 md:grid-cols-2 lg:grid-cols-3'}`}>
              <li className="flex items-center space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-5 h-5 fill-current text-Eerie-Black dark:text-Ripe-mango">
                      <path d="M426.072,86.928A238.75,238.75,0,0,0,88.428,424.572,238.75,238.75,0,0,0,426.072,86.928ZM257.25,462.5c-114,0-206.75-92.748-206.75-206.75S143.248,49,257.25,49,464,141.748,464,255.75,371.252,462.5,257.25,462.5Z"></path>
                      <polygon points="221.27 305.808 147.857 232.396 125.23 255.023 221.27 351.063 388.77 183.564 366.142 160.937 221.27 305.808"></polygon>
                  </svg>
                  <span>{t('Features.employeeDocumentation')}</span>
              </li>
              <li className="flex items-center space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-5 h-5 fill-current text-Eerie-Black dark:text-Ripe-mango">
                      <path d="M426.072,86.928A238.75,238.75,0,0,0,88.428,424.572,238.75,238.75,0,0,0,426.072,86.928ZM257.25,462.5c-114,0-206.75-92.748-206.75-206.75S143.248,49,257.25,49,464,141.748,464,255.75,371.252,462.5,257.25,462.5Z"></path>
                      <polygon points="221.27 305.808 147.857 232.396 125.23 255.023 221.27 351.063 388.77 183.564 366.142 160.937 221.27 305.808"></polygon>
                  </svg>
                  <span>{t('Features.attendanceManagement')}</span>
              </li>
              <li className="flex items-center space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-5 h-5 fill-current text-Eerie-Black dark:text-Ripe-mango">
                      <path d="M426.072,86.928A238.75,238.75,0,0,0,88.428,424.572,238.75,238.75,0,0,0,426.072,86.928ZM257.25,462.5c-114,0-206.75-92.748-206.75-206.75S143.248,49,257.25,49,464,141.748,464,255.75,371.252,462.5,257.25,462.5Z"></path>
                      <polygon points="221.27 305.808 147.857 232.396 125.23 255.023 221.27 351.063 388.77 183.564 366.142 160.937 221.27 305.808"></polygon>
                  </svg>
                  <span>{t('Features.transactionPlanning')}</span>
              </li>
              <li className="flex items-center space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-5 h-5 fill-current text-Eerie-Black dark:text-Ripe-mango">
                      <path d="M426.072,86.928A238.75,238.75,0,0,0,88.428,424.572,238.75,238.75,0,0,0,426.072,86.928ZM257.25,462.5c-114,0-206.75-92.748-206.75-206.75S143.248,49,257.25,49,464,141.748,464,255.75,371.252,462.5,257.25,462.5Z"></path>
                      <polygon points="221.27 305.808 147.857 232.396 125.23 255.023 221.27 351.063 388.77 183.564 366.142 160.937 221.27 305.808"></polygon>
                  </svg>
                  <span>{t('Features.projectManagement')}</span>
              </li>
              <li className="flex items-center space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-5 h-5 fill-current text-Eerie-Black dark:text-Ripe-mango">
                      <path d="M426.072,86.928A238.75,238.75,0,0,0,88.428,424.572,238.75,238.75,0,0,0,426.072,86.928ZM257.25,462.5c-114,0-206.75-92.748-206.75-206.75S143.248,49,257.25,49,464,141.748,464,255.75,371.252,462.5,257.25,462.5Z"></path>
                      <polygon points="221.27 305.808 147.857 232.396 125.23 255.023 221.27 351.063 388.77 183.564 366.142 160.937 221.27 305.808"></polygon>
                  </svg>
                  <span>{t('Features.appointmentScheduling')}</span>
              </li>
              <li className="flex items-center space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-5 h-5 fill-current text-Eerie-Black dark:text-Ripe-mango">
                      <path d="M426.072,86.928A238.75,238.75,0,0,0,88.428,424.572,238.75,238.75,0,0,0,426.072,86.928ZM257.25,462.5c-114,0-206.75-92.748-206.75-206.75S143.248,49,257.25,49,464,141.748,464,255.75,371.252,462.5,257.25,462.5Z"></path>
                      <polygon points="221.27 305.808 147.857 232.396 125.23 255.023 221.27 351.063 388.77 183.564 366.142 160.937 221.27 305.808"></polygon>
                  </svg>
                  <span>{t('Features.newsUpdates')}</span>
              </li>
          </ul>
      </div>
        <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20 ">
          <div className="max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12">
            <div>
              <p className="inline-block px-3 py-px mb-4 text-xs font-semibold tracking-wider text-white uppercase rounded-full bg-Ripe-mango">
                Brand new
              </p>
            </div>
            <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-Eerie-Black dark:text-white sm:text-4xl md:mx-auto">
              <span className="relative inline-block ">
                <svg
                  viewBox="0 0 52 24"
                  fill="currentColor"
                  className="absolute top-0 left-0 z-0 hidden w-32 -mt-8 -ml-20 text-Ripe-mango lg:w-32 lg:-ml-28 lg:-mt-10 sm:block"
                >
                  <defs>
                    <pattern
                      id="07690130-d013-42bc-83f4-90de7ac68f76"
                      x="0"
                      y="0"
                      width=".135"
                      height=".30"
                    >
                      <circle cx="1" cy="1" r=".7" />
                    </pattern>
                  </defs>
                  <rect
                    fill="url(#07690130-d013-42bc-83f4-90de7ac68f76)"
                    width="52"
                    height="24"
                  />
                </svg>
                <span className="relative">{t('Features.Empower')}</span>
              </span>{' '}
              {t('Features.empoweringTagline')} </h2>
            <p className="text-base text-Eerie-Black-light dark:text-gray-300 md:text-lg">
              {t('Features.empoweringDesc')}</p>
          </div>
          <div className="grid max-w-screen-lg mx-auto space-y-6 lg:grid-cols-2 lg:space-y-0 lg:divide-x">
            <div className="space-y-6 sm:px-16">
              <div className="flex flex-col max-w-md sm:flex-row">
                <div className="mb-4 mr-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-300 dark:bg-Ripe-mango ">
                    <svg
                      className="w-8 h-8 text-Eerie-Black dark:text-white sm:w-10 sm:h-10"
                      stroke="currentColor"
                      viewBox="0 0 52 52"
                    >
                      <polygon
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                        points="29 13 14 29 25 29 23 39 38 23 27 23"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h6 className="mb-3 text-xl text-Eerie-Black dark:text-white font-bold leading-5">
                  {t('Features.employeeDocumentManagement')}</h6>
                  <p className="text-sm text-Eerie-Black dark:text-white">
                  {t('Features.employeeDocumentManagementDesc')}                  </p>
                </div>
              </div>
              <div className="flex flex-col max-w-md sm:flex-row">
                <div className="mb-4 mr-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-300 dark:bg-Ripe-mango">
                    <svg
                      className="w-8 h-8 text-Eerie-Black dark:text-white sm:w-10 sm:h-10"
                      stroke="currentColor"
                      viewBox="0 0 52 52"
                    >
                      <polygon
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                        points="29 13 14 29 25 29 23 39 38 23 27 23"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h6 className="mb-3 text-xl text-Eerie-Black dark:text-white font-bold leading-5">
                  {t('Features.attendanceTracking')}
                  </h6>
                  <p className="text-sm text-Eerie-Black dark:text-white ">
                  {t('Features.attendanceTrackingDesc')}                  </p>
                </div>
              </div>
              <div className="flex flex-col max-w-md sm:flex-row">
                <div className="mb-4 mr-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-300 dark:bg-Ripe-mango">
                    <svg
                      className="w-8 h-8 text-Eerie-Black dark:text-white sm:w-10 sm:h-10"
                      stroke="currentColor"
                      viewBox="0 0 52 52"
                    >
                      <polygon
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                        points="29 13 14 29 25 29 23 39 38 23 27 23"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h6 className="mb-3 text-xl text-Eerie-Black dark:text-white font-bold leading-5">
                  {t('Features.employeeDocumentManagement')}                  </h6>
                  <p className="text-sm text-Eerie-Black dark:text-white">
                  {t('Features.employeeDocumentManagementDesc')}
                  </p>
                </div>
              </div>
            </div>
            <div className="space-y-6 sm:px-16">
              <div className="flex flex-col max-w-md sm:flex-row">
                <div className="mb-4 mr-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-300 dark:bg-Ripe-mango">
                    <svg
                      className="w-8 h-8 text-Eerie-Black dark:text-white sm:w-10 sm:h-10"
                      stroke="currentColor"
                      viewBox="0 0 52 52"
                    >
                      <polygon
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                        points="29 13 14 29 25 29 23 39 38 23 27 23"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h6 className="mb-3 text-xl text-Eerie-Black dark:text-white font-bold leading-5">
                  {t('Features.financialTransactionPlanning')}
                  </h6>
                  <p className="text-sm text-Eerie-Black dark:text-white ">
                  {t('Features.financialTransactionPlanningDesc')}
                  </p>
                </div>
              </div>
              <div className="flex flex-col max-w-md sm:flex-row">
                <div className="mb-4 mr-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-300 dark:bg-Ripe-mango">
                    <svg
                      className="w-8 h-8 text-Eerie-Black dark:text-white sm:w-10 sm:h-10"
                      stroke="currentColor"
                      viewBox="0 0 52 52"
                    >
                      <polygon
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                        points="29 13 14 29 25 29 23 39 38 23 27 23"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h6 className="mb-3 text-xl text-Eerie-Black dark:text-white font-bold leading-5">
                  {t('Features.projectManagement')}
                  </h6>
                  <p className="text-sm text-Eerie-Black dark:text-white">
                  {t('Features.projectManagementDesc')}

                  </p>
                </div>
              </div>
              <div className="flex flex-col max-w-md sm:flex-row">
                <div className="mb-4 mr-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-300 dark:bg-Ripe-mango">
                    <svg
                      className="w-8 h-8 text-Eerie-Black dark:text-white sm:w-10 sm:h-10"
                      stroke="currentColor"
                      viewBox="0 0 52 52"
                    >
                      <polygon
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                        points="29 13 14 29 25 29 23 39 38 23 27 23"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h6 className="mb-3 text-xl text-Eerie-Black dark:text-white font-bold leading-5">
                  {t('Features.scheduledAppointments')}
                  </h6>
                  <p className="text-sm text-Eerie-Black dark:text-white">
                  {t('Features.scheduledAppointmentsDesc')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>
      );
}

export default Features
